<template>
  <div class="container">
    <loader-overlay v-if="apiRslt.fetch.inProgress"/>

    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4" data-cy="title">Réinitialisation du mot de passe </h1>
                    <p class="small" data-cy="subtitle">Veuillez définir un nouveau mot de passe personnel</p>
                  </div>
                  <form class="user" >
                    <div class="row">
                      <div class="col-md-12 mb-2">
                        <password-field
                            name="Mot de passe"
                            property="oldPassword"
                            :type="type"
                            v-model="form.oldPassword"
                            :error="$v.form.oldPassword.$error"
                            errorCode="MESS001"
                        >
                          <template #resetPassword>
                            <button class="btn btn-outline-secondary" style="border-radius: 0px;" type="button" @click="seePassword()">
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            </button>
                          </template>
                        </password-field>
                      </div>
                      <div class="col-md-12 mb-2">
                        <password-field
                            name="Mot de passe"
                            property="newPassword"
                            :type="type"
                            v-model="form.newPassword"
                            :error="$v.form.newPassword.$error"
                            errorCode="MESS014"
                        >
                          <template #resetPassword>
                            <button class="btn btn-outline-secondary" style="border-radius: 0px;" type="button" @click="seePassword()">
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            </button>
                          </template>
                        </password-field>
                        <div class="invalid" v-show="$v.form.newPassword.$error"> 
                          <ul>
                            <li>Le mot de passe doit contenir au moins 8 caractères </li>
                            <li>Le mot de passe doit contenir au moins <b>1 lettre MAJUSCULE,</b></li>
                            <li>Le mot de passe doit contenir au moins <b>1 lettre minuscule, </b></li>
                            <li>Le mot de passe doit contenir au moins  <b>1 caractère spécial (@#&%!=?+-*/)</b></li>
                          </ul>                     
                        </div>
  
                      </div>
                      <div class="col-md-12">
                        <text-field
                            name="Confirmation mot de passe"
                            property="repeatPassword"
                            :type="type"
                            v-model="form.repeatPassword"
                            :error="$v.form.repeatPassword.$error"
                            errorCode="MESS013"
                        />
                      </div>
                    </div>  
                    <a data-cy="btn_maj_pwd" @click="firstVisitOk()" class="btn btn-primary btn-user btn-block mt-5">
                      Mettre à jour 
                    </a>                  
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { TextField, PasswordField } from "@/core/components/form";
import { mapState, mapActions } from 'vuex';
import { required, minLength, sameAs } from "vuelidate/lib/validators"
import LoaderOverlay from "@/core/components/LoaderOverlay.vue";


const containsUppercase = (value) => /[A-Z]/.test(value)
const containsLowercase = (value) => /[a-z]/.test(value)
// const containsNumber = (value) => /[0-9]/.test(value)
const containsSpecial = (value) => /[#?!@$%^&*-]/.test(value)


export default {
  name: 'Users',
  components: { TextField, PasswordField, LoaderOverlay },
  computed: {
    ...mapState('auth',['fullUser','user','apiRslt'])
  },
  data() {
    return {
      type:'password',
      form: {
        oldPassword:'',
        newPassword:'',
        repeatPassword:''
      }
    }
  },
  created(){
    if(!this.fullUser.isFirstConnexion){
      this.$router.push({ name: 'home' })
    }
  },
  mounted() {
    this.$v.form.$reset()
  },
  methods: {
    ...mapActions('auth',['updatePassword']),
    firstVisitOk(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error){
        this.updatePassword({
          'username':this.fullUser.username,
          'oldPassword':this.form.oldPassword,
          'newPassword':this.form.newPassword
        })
      }
    },
    seePassword(){
      this.type = 'text'
      setTimeout(() => {
        this.type = 'password'
      }, 1000)
    }
  },
  validations: {
    form:{
        oldPassword:{ required },
        newPassword: {
          required,
          containsUppercase,
          containsLowercase,
          containsSpecial,
          minLength: minLength(6)
        },
        repeatPassword: {
          sameAsPassword: sameAs('newPassword')
        }
    }
    
  },
}
</script>

<style scoped>

</style>
